import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_CHECKLISTS_ACTION_TYPE } from '../actions';

const initialState = [];

const subCompanyChecklistsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case SUB_COMPANY_CHECKLISTS_ACTION_TYPE.GET_RESULTS:
        return payload || initialState;

      case SUB_COMPANY_CHECKLISTS_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyChecklistsReducer;
